import { ICanton } from '@app/interfaces/config';
import { isAdminToolSsoAvailable, normalizeAdminToolSsoMode } from '@app/constants/enums/adminToolSsoMode';

/** True when canton SSO mode is On (1) or SsoOnly (2). Default On when unset. */
export const isAdminToolSsoEnabled = (currentCanton?: ICanton): boolean =>
  isAdminToolSsoAvailable(normalizeAdminToolSsoMode(currentCanton?.adminToolSsoEnabled));
